import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { createVariantDimension, updateVariantDimension } from "../api/variantDimensions";

function VariantDimensionModal({ data, onClose, onSaved }) {
  const [key, setKey] = useState("");
  const [label, setLabel] = useState("");
  const [valueType, setValueType] = useState("option");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (data) {
      setKey(data.key || "");
      setLabel(data.label || "");
      setValueType(data.value_type || "option");
    } else {
      setKey("");
      setLabel("");
      setValueType("option");
    }
  }, [data]);

  async function save() {
    setError("");
    const k = String(key || "").trim();
    const l = String(label || "").trim();

    if (!l || (!data && !k)) {
      setError("Key ve label zorunlu.");
      return;
    }

    const payload = {
      ...(data ? {} : { key: k }),
      label: l,
      value_type: valueType,
    };

    const req = data
      ? updateVariantDimension(data.id, payload)
      : createVariantDimension(payload);

    setSaving(true);
    try {
      await req;
      await onSaved?.();
      onClose?.();
    } catch (err) {
      console.error("DIMENSION SAVE ERROR", err);
      const status = err?.response?.status;
      const dataObj = err?.response?.data;
      const message =
        dataObj?.error?.message ||
        dataObj?.message ||
        (typeof dataObj === "string" ? dataObj : null) ||
        err?.message ||
        null;
      setError(`Kaydedilemedi${status ? ` (HTTP ${status})` : ""}${message ? `: ${message}` : ""}`);
    } finally {
      setSaving(false);
    }
  }

  return (
    <Dialog open onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          {data ? "Varyant Anahtarı Düzenle" : "Yeni Varyant Anahtarı"}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Malzeme varyantlarında kullanılacak anahtarı tanımlayın.
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}

          {!data ? (
            <TextField
              label="Key (örn: color, gsm, width_mm)"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              required
              disabled={saving}
            />
          ) : (
            <TextField label="Key" value={key} disabled />
          )}

          <TextField
            label="Label (örn: Renk, Gramaj)"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            required
            disabled={saving}
          />

          <FormControl>
            <InputLabel id="value-type-label">Tip</InputLabel>
            <Select
              labelId="value-type-label"
              label="Tip"
              value={valueType}
              onChange={(e) => setValueType(e.target.value)}
              disabled={saving}
            >
              <MenuItem value="option">Seçenek (Dropdown)</MenuItem>
              <MenuItem value="number">Sayı</MenuItem>
              <MenuItem value="text">Metin</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={saving}>
          İptal
        </Button>
        <Button onClick={save} variant="contained" disabled={saving}>
          {saving ? "Kaydediliyor..." : "Kaydet"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default VariantDimensionModal;

